import {
  PRODUCT_CATEGORIES,
  PRODUCT_MENU_GROUPS,
  PRODUCT_SOURCING_TYPES,
} from "@artisancode/api-types";
import { z } from "zod";

export const productSchema = z.object({
  name: z.string().min(1, "Nama produk wajib diisi"),
  sku: z.string().optional(),
  category: z.enum(PRODUCT_CATEGORIES),
  menuGroup: z.enum(PRODUCT_MENU_GROUPS),
  sourcingType: z.enum(PRODUCT_SOURCING_TYPES),
  photoKey: z.string().nullable().optional(),
  sellingPrice: z.number().min(0).optional(),
  minStock: z.number().min(0).optional(),
  notes: z.string().optional(),
  workspaceId: z.string().optional(),
});

export type ProductFormValues = z.infer<typeof productSchema>;

export const defaultProductValues: ProductFormValues = {
  name: "",
  sku: "",
  category: "beverage",
  menuGroup: "coffee",
  sourcingType: "produced",
  photoKey: null,
  sellingPrice: undefined,
  minStock: undefined,
  notes: "",
  workspaceId: "",
};
